module.exports = __webpack_public_path__ + "img/shirt-running.c80cdcc2.svg";